var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo[data-v-7cff6c4b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:32px 0 29px}.logo .imgUrl[data-v-7cff6c4b]{width:46px;height:43px;cursor:pointer;background-image:url(" + escape(require("./img/logo.png")) + ")}.logo .imgUrl a[data-v-7cff6c4b]{width:100%;height:100%;display:inline-block}.logo .title[data-v-7cff6c4b]{margin-left:10px;font-size:30px;font-weight:700;font-family:Microsoft Yahei}", ""]);

// exports
